import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@Shared/components/general/page-header";
import InactiveActions from "./inactive-actions";
import InactiveTable from "./inactive-table";
import ReactivateModal from "./reactivate-modal";
import InactiveLoader from "./inactive-loader";
import LoadMore from "./load-more";
import { mapState, mapGetters, mapActions } from "vuex";
import { INACTIVE_CLIENTS_LOADED, BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
import { LOAD_INACTIVE_CLIENTS } from "@Broker/@Modules/clients/board/store/board-actions";
import TooltipsMixin from "@Shared/utils/shared-mixins/tooltips-mixin";
import { LOAD_BOARDS } from "@Broker/@Modules/clients/board/store/board-actions";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InactiveContainer",
  title() {
    return this.$t("sidebar.sections.inactiveClients");
  },
  components: {
    PageHeader,
    InactiveActions,
    InactiveTable,
    ReactivateModal,
    InactiveLoader,
    LoadMore
  },
  mixins: [TooltipsMixin],
  data() {
    return {
      reactiveClientProfile: {
        id: "",
        boardId: ""
      },
      loading: true,
      loadTable: false,
      loadingMore: false,
      DEFAULT_LIMIT: 20,
      SCROLL_OFFSET: 200
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("BoardStore", ["inactiveTable"])), mapGetters("BoardStore", [INACTIVE_CLIENTS_LOADED, BOARDS])), {}, {
    currentInactive() {
      var _context;
      return _mapInstanceProperty(_context = this.inactiveTable.inactiveClientProfiles.allIds).call(_context, id => this.inactiveTable.inactiveClientProfiles.byId[id]);
    },
    searchString() {
      return this.inactiveTable.inactiveTableFilters.searchString;
    }
  }),
  beforeDestroy() {
    this.destroy();
  },
  activated() {
    this.init();
    this.handleScroll();
    Amplitude.logEvent("Inactive Clients - visited");
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_BOARDS, LOAD_INACTIVE_CLIENTS])), {}, {
    destroy() {
      $("#page").off("scroll.application-infinite-scroll");
      this.destroyTooltips();
    },
    showReactivateClientModal({
      id,
      boardId
    }) {
      this.reactiveClientProfile.id = id;
      this.reactiveClientProfile.boardId = boardId;
      this.$refs.reactivateClientModal.show();
    },
    async handleSort({
      orderBy,
      orderType,
      boardIds
    }) {
      this.loadTable = true;
      await this.LOAD_INACTIVE_CLIENTS({
        limit: this.INACTIVE_CLIENTS_LOADED > this.DEFAULT_LIMIT ? this.INACTIVE_CLIENTS_LOADED : this.DEFAULT_LIMIT,
        orderBy,
        orderType,
        boardIds
      });
      this.loadTable = false;
      this.initTooltips();
    },
    async searchClients(searchString) {
      this.loadTable = true;
      await this.LOAD_INACTIVE_CLIENTS({
        searchString
      });
      this.loadTable = false;
      this.initTooltips();
    },
    async init() {
      this.loading = true;
      const limit = this.INACTIVE_CLIENTS_LOADED > this.DEFAULT_LIMIT ? this.INACTIVE_CLIENTS_LOADED : this.DEFAULT_LIMIT;
      await _Promise.all([this.LOAD_INACTIVE_CLIENTS({
        limit
      })]);
      if (!this.BOARDS.length) this.LOAD_BOARDS();
      this.loading = false;
      this.initTooltips();
    },
    handleScroll() {
      $("#page").on("scroll.application-infinite-scroll", event => {
        const scroller = $(event.currentTarget);
        if (scroller.scrollTop() + this.SCROLL_OFFSET + scroller.innerHeight() >= scroller[0].scrollHeight) {
          if (this.inactiveTable.totalInactive > this.INACTIVE_CLIENTS_LOADED && !this.loadingMore) this.loadMoreClients();
        }
      });
    },
    async handleUpdate() {
      this.loading = true;
      const limit = this.INACTIVE_CLIENTS_LOADED > this.DEFAULT_LIMIT ? this.INACTIVE_CLIENTS_LOADED : this.DEFAULT_LIMIT;
      await this.LOAD_INACTIVE_CLIENTS({
        limit
      });
      this.loading = false;
      this.initTooltips();
    },
    async loadMoreClients() {
      this.loadingMore = true;
      await this.LOAD_INACTIVE_CLIENTS({
        offset: this.INACTIVE_CLIENTS_LOADED
      });
      this.loadingMore = false;
      this.initTooltips();
    }
  })
});